module.exports = __webpack_public_path__ + "static/img/login_remind@3x.b50fe05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_remind@3x.png
// module id = bVCm
// module chunks = 1